import script from "./announcements-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./announcements-card.vue?vue&type=script&setup=true&lang=ts"

import "./announcements-card.vue?vue&type=style&index=0&id=b3848eea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3848eea"]])

export default __exports__